import React from "react";

interface ScrollToTopProps {
    show: boolean;
    onClick?: () => void;
    className?: string;
    position?: "bottom-right" | "bottom-left";
}

/**
 * Scroll to Top Button Component
 */
export const ScrollToTop: React.FC<ScrollToTopProps> = ({
    show,
    onClick,
    className = "",
    position = "bottom-right",
}) => {
    const handleClick = () => {
        if (onClick) {
            onClick();
        } else {
            window.scrollTo({ top: 0, behavior: "smooth" });
        }
    };

    const positionClasses = {
        "bottom-right": "bottom-6 right-6 md:bottom-10",
        "bottom-left": "bottom-6 left-6 md:bottom-10",
    };

    return (
        <button
            onClick={handleClick}
            className={`
        group cursor-pointer hover:scale-115 fixed ${positionClasses[position]} 
        bg-[#e7000b] text-white rounded-full p-3 shadow-lg hover:bg-[#e7000b]/90 
        transition-all duration-300 z-40 ${className}
        ${
            show
                ? "opacity-100 translate-y-0 pointer-events-auto"
                : "opacity-0 translate-y-4 pointer-events-none"
        }
      `}
            aria-label="Scroll to top"
        >
            <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-6 w-6 group-hover:scale-125 transition-all"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
            >
                <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M5 15l7-7 7 7"
                />
            </svg>
        </button>
    );
};
